import { Component } from '@angular/core';

@Component({
  selector: 'skada',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
}
